import type { ReactNode } from 'react';

const URL_PATTERN = /\b(https?:\/\/[^\s<]+[^\s<.,;:!?)\]}])/gi;

/**
 * Renders free text and turns http(s) URLs into accent-colored links that
 * open in a new tab. Preserves whitespace via the caller's wrapping element
 * (use `whitespace-pre-line` on the parent for poznámka-style blocks).
 */
export function linkify(text: string | null | undefined): ReactNode {
  if (!text) return text ?? '';
  const out: ReactNode[] = [];
  let last = 0;
  let i = 0;
  for (const m of text.matchAll(URL_PATTERN)) {
    const start = m.index ?? 0;
    if (start > last) out.push(text.slice(last, start));
    out.push(
      <a
        key={`u${i++}`}
        href={m[0]}
        target="_blank"
        rel="noreferrer noopener"
        className="text-accent-text underline decoration-line decoration-dotted underline-offset-2 hover:decoration-accent"
      >
        {m[0]}
      </a>,
    );
    last = start + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
